import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAccountParentCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2308 9.07692H13.6923V10.6154H15.2308V9.07692Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2308 12.1538H13.6923V13.6923H15.2308V12.1538Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2308 15.2308H13.6923V16.7692H15.2308V15.2308Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2308 18.3077H13.6923V19.8462H15.2308V18.3077Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3077 9.07692H16.7692V10.6154H18.3077V9.07692Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3077 12.1538H16.7692V13.6923H18.3077V12.1538Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3077 15.2308H16.7692V16.7692H18.3077V15.2308Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3077 18.3077H16.7692V19.8462H18.3077V18.3077Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.2308 24.4615H21.3846V10.6154H22.9231V22.1538C22.9231 22.3579 23.0041 22.5535 23.1484 22.6978C23.2926 22.842 23.4883 22.9231 23.6923 22.9231C23.8963 22.9231 24.092 22.842 24.2362 22.6978C24.3805 22.5535 24.4615 22.3579 24.4615 22.1538V9.84615C24.4615 9.64214 24.3805 9.44648 24.2362 9.30223C24.092 9.15797 23.8963 9.07692 23.6923 9.07692H21.3846V6.76923C21.3846 6.56522 21.3036 6.36956 21.1593 6.2253C21.0151 6.08104 20.8194 6 20.6154 6H11.3846C11.1806 6 10.9849 6.08104 10.8407 6.2253C10.6964 6.36956 10.6154 6.56522 10.6154 6.76923V9.07692H8.30769C8.10368 9.07692 7.90802 9.15797 7.76376 9.30223C7.61951 9.44648 7.53846 9.64214 7.53846 9.84615V24.4615H6.76923C6.56522 24.4615 6.36956 24.5426 6.2253 24.6868C6.08104 24.8311 6 25.0268 6 25.2308C6 25.4348 6.08104 25.6304 6.2253 25.7747C6.36956 25.919 6.56522 26 6.76923 26H25.2308C25.4348 26 25.6304 25.919 25.7747 25.7747C25.919 25.6304 26 25.4348 26 25.2308C26 25.0268 25.919 24.8311 25.7747 24.6868C25.6304 24.5426 25.4348 24.4615 25.2308 24.4615ZM9.07692 10.6154H10.6154V22.1538C10.6154 22.3579 10.6964 22.5535 10.8407 22.6978C10.9849 22.842 11.1806 22.9231 11.3846 22.9231C11.5886 22.9231 11.7843 22.842 11.9285 22.6978C12.0728 22.5535 12.1538 22.3579 12.1538 22.1538V7.53846H19.8462V24.4615H18.3077V22.1538C18.3077 21.9498 18.2266 21.7542 18.0824 21.6099C17.9381 21.4657 17.7425 21.3846 17.5385 21.3846H14.4615C14.2575 21.3846 14.0619 21.4657 13.9176 21.6099C13.7734 21.7542 13.6923 21.9498 13.6923 22.1538V24.4615H9.07692V10.6154ZM16.7692 24.4615H15.2308V22.9231H16.7692V24.4615Z",
				fill: "white"
			})
		] }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", { children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(6 6)"
		}) }) })
	]
});
export default SvgIconAccountParentCircle;
